import enums from './enums';
import external_urls from './external_urls';
import misc from './misc';
import page from './page';
import { validator, names as validator_names } from './validator';

export default {
    enums,
    validator,
    validator_names,
    external_urls,
    _page: page,
    ...misc
};
